/** Origem HTTP da API gRPC-Web (mesma porta da REST, sem /api). */
export function grpcBaseUrl() {
    const explicit = (process.env.REACT_APP_GRPC_BASE_URL || '').trim().replace(/\/+$/, '');
    if (explicit) {
        return explicit;
    }

    const apiBase = (process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/+$/, '');
    if (!apiBase) {
        return 'http://localhost:8080';
    }

    try {
        const url = new URL(apiBase.endsWith('/') ? apiBase : `${apiBase}/`);
        return url.origin;
    } catch {
        return apiBase.replace(/\/api\/?$/, '');
    }
}

export function isGrpcEnabled() {
    const flag = process.env.REACT_APP_USE_GRPC || process.env.REACT_APP_USE_GRPC_DASHBOARD || '';
    return String(flag).trim().toLowerCase() === 'true';
}

/** @deprecated use isGrpcEnabled */
export function isGrpcDashboardEnabled() {
    return isGrpcEnabled();
}
